import React from 'react';
import { StrategicMap } from '../components/StrategicMap';
import { Building2, Clock, ShieldCheck, MapPin } from 'lucide-react';
import { PageWrapper, SectionWrapper } from '../components/MotionWrappers';
export function Locations() {
  return <PageWrapper data-id="element-619">
      <div className="bg-white" data-id="element-620">
        <div className="bg-federal-blue py-16 text-white" data-id="element-621">
          <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-622">
            <h1 className="text-4xl md:text-5xl font-black mb-4" data-id="element-623">
              Strategic Locations
            </h1>
            <p className="text-white/70 max-w-2xl text-lg" data-id="element-624">
              Positioned for rapid response and high-touch support across the
              Mid-Atlantic and Southeast.
            </p>
          </div>
        </div>
        <SectionWrapper data-id="element-625">
          <StrategicMap data-id="element-626" />
        </SectionWrapper>
        <section className="py-16 bg-white" data-id="element-627">
          <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-628">
            <div className="grid md:grid-cols-2 gap-12" data-id="element-629">
              <SectionWrapper data-id="element-630">
                <div className="p-8 border border-slate-200 rounded-sm bg-slate-50 h-full transition-shadow hover:shadow-md" data-id="element-631">
                  <div className="flex items-center gap-3 mb-6" data-id="element-632">
                    <MapPin className="w-6 h-6 text-federal-blue" data-id="element-633" />
                    <h3 className="text-2xl font-black text-federal-blue uppercase" data-id="element-634">
                      Charlotte Hub
                    </h3>
                  </div>
                  <ul className="space-y-4 text-tech-slate" data-id="element-635">
                    <li className="flex items-center gap-3" data-id="element-636">
                      <Building2 className="w-4 h-4 text-federal-blue opacity-50" data-id="element-637" />{' '}
                      Regional Headquarters & Logistics
                    </li>
                    <li className="flex items-center gap-3" data-id="element-638">
                      <Clock className="w-4 h-4 text-federal-blue opacity-50" data-id="element-639" />{' '}
                      24/7 Technical Support Center
                    </li>
                    <li className="flex items-center gap-3" data-id="element-640">
                      <ShieldCheck className="w-4 h-4 text-federal-blue opacity-50" data-id="element-641" />{' '}
                      Secure Hardware Staging Facility
                    </li>
                  </ul>
                </div>
              </SectionWrapper>
              <SectionWrapper delay={0.1} data-id="element-642">
                <div className="p-8 border border-slate-200 rounded-sm bg-slate-50 h-full transition-shadow hover:shadow-md" data-id="element-643">
                  <div className="flex items-center gap-3 mb-6" data-id="element-644">
                    <MapPin className="w-6 h-6 text-federal-blue" data-id="element-645" />
                    <h3 className="text-2xl font-black text-federal-blue uppercase" data-id="element-646">
                      Baltimore Hub
                    </h3>
                  </div>
                  <ul className="space-y-4 text-tech-slate" data-id="element-647">
                    <li className="flex items-center gap-3" data-id="element-648">
                      <Building2 className="w-4 h-4 text-federal-blue opacity-50" data-id="element-649" />{' '}
                      Federal Agency Liaison Office
                    </li>
                    <li className="flex items-center gap-3" data-id="element-650">
                      <Clock className="w-4 h-4 text-federal-blue opacity-50" data-id="element-651" />{' '}
                      Rapid Response Field Engineering
                    </li>
                    <li className="flex items-center gap-3" data-id="element-652">
                      <ShieldCheck className="w-4 h-4 text-federal-blue opacity-50" data-id="element-653" />{' '}
                      Compliance & Security Audit Lab
                    </li>
                  </ul>
                </div>
              </SectionWrapper>
            </div>
          </div>
        </section>
      </div>
    </PageWrapper>;
}